<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12>
                  <v-text-field 
                    label="ประเภทบุคคล" 
                    v-model="item.name" 
                    :rules="[rules.required]" 
                    required 
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea multi-line label="หมายเหตุ" v-model="item.remark"></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox label="บุคลากรภายใน" v-model="item.insider"></v-checkbox>
                </v-flex>  
            </v-layout>
          </v-container>
        </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSave">บันทึก</v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: ['dialog', 'item', 'title'],
  data () {
    return {
      loading: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
    }
  },
  methods: {
    close: function() {
      this.$emit('dialog', false)
    },
    onSave () {
      console.log('onSave called...', this.item )
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'personType/update' : 'personType/create'
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            console.log('onSave:', response )
            this.loading = false
            swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
    
  },
  watch: {
    
  }
}

</script>


// WEBPACK FOOTER //
// src/components/settings/personType/formDialog.vue